import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {Helmet} from 'react-helmet';
import isEmpty  from 'lodash/isEmpty';
import { initializeEventList, clearActiveEvent, startGetMyEventMetrics, clearAllEventMetrics } from '../actions/event'; 
import { CancelSubmitModal } from './modals/CancelSubmitModal';
import { picAppError } from '../actions/picapp'; 
import { updateItemList } from '../actions/items'; 
import { startDeleteEvent } from '../actions/event'; 
import  axios from 'axios';
// import { FooterSection } from './FooterSection'; 
import Footer from "../components/common/Footer";
import  PicEventsTable  from './PicEventsTable';
import  PicEventsSearchBar  from './PicEventsSearchBar';
import { SimpleMetric } from './metrics/SimpleMetric';
import  VisibilityWrapper      from "../components/common/VisibilityWrapper";
import { displayAd } from './advertisements/helpers/displayAd';
import  PlusIcon  from './icons/PlusIcon';
import  MuiVertMenu from './MuiVertMenu'
import  format from 'date-fns/format';
import  isAfter from 'date-fns/isAfter';
import  isBefore from 'date-fns/isBefore';
import  getAppConfigParm  from '../config/AppConfig';
import  ProgressSpinner from './ProgressSpinner'
// import { runInThisContext } from 'vm';
import { addConditionalClassIf } from '../utils/addConditionalClassIf';
import { startGetEventsInvitedTo } from '../actions/event';
import  { prtStart, prtEnd, prtInput, prtStep, prtVar, prtOutput, prtErr } from "../utils/prt"; 
// import { GoogleAdInit } from './advertisement/GoogleAdInit';

// const styles = theme => ({
//     fab: {
//        margin: theme.spacing.unit,
//     },
//     extendedIcon: {
//         marginRight: theme.spacing.unit,
//     },  
// });

var trace = true;
var compName = "DashboardPage";

// ***********************************************************************************
// Inputs: 
// - searchFilterValue, which passed via props for PicEventsSearchBar
// - getSearchValue function - callback to be able to get searh value from PicEventsSearchBar
// - clearSearchValue function - callback to be able to set searh in the PicEventsSearchBar
// - eventListFilter - prop is set by the EventFilterMenu on the PicEventsSearchBar.
//   It updates the redux then is passed as prop via mapStateToProps.
//
// External Components
// - PicEventsSearchBar - search bar shown above the event list
// - PicEventsTable -  This is a flex table component that takes as props an array of 
//   rows (each row has array of column/cells) that allows for a fixed number of columns (eg 3 or 4). 
//   Note that the contents of each cell or column in the flex table can be text or jsx. The 
//   mapping of the data to the JSX structures is done in the render function, with the use of 
//   some getColumn... helper functions.
//
// Dashboard process.
// - ComponentDidMount, by default, loads all My Events and gets the Event Metrics.
// - render()  - creates the PicEventsTableJsx based on eventListFilter specified and passes
//               the styled list to it after applying the filter logic 
//             - renderMyEventsTable - called within render to display events for 
//               either All My Events, My Upcoming Events, and My Past Events
//             - renderEventsInvitedToTable - called within render to display "Events Invited To"
// ***********************************************************************************

export class DashboardPage extends React.Component { 

    constructor(props) {
        //trace && prtStart(compName, 'constructor');
        super(props);

        this.state = {
            searchValue: '',            //used for displaying value in the UI search field
            searchFilterValue: '',      //used for filtering events in render function based on searchValue text
            getSearchValue: '',         //Function in SearchField component that is registered here via registrationFunction prop to be able to get search value
            clearSearchValue: '',       //Function in SearchField component that is registered here via registrationFunction prop to be able to clear search value,
            dataLoaded: false,
            currentEventObject: {},
            showModal: false 
        }
    }

    //*************************************************************************
    // Lifecycle methods
    //*************************************************************************

    // Initialize event list
    componentDidMount = () => {
        //trace && prtStart(compName, `ComponentDidMount`);

        /* clear all event metrics on redux store. Spinner will go away once these are populated */
        this.props.clearAllEventMetrics();

        /* For some reason, only during login, the getEventList and getMetrics was called two times.
           The only thing that seemed to solve this problem was to make sure login process
           was completed before making call, hence why the if statement below.  It seems it does not 
           affect anything else as the only time it will not run is if we are loggin in. */
        if (!this.props.auth.loginInProgress) {
                /* Call api to get list of events then dispatch call to get metrics for each event  */
                this.getEventList().then((events) => {
                this.props.startGetMyEventMetrics(events);
            }).catch((errmsg) => {  
                errmsg = "Server issue. Please try again later."; /* create user friendly message */
                this.props.picAppError(errmsg);
            })
        }
    }

    //*************************************************************************
    // Event Handlers
    //*************************************************************************

    handleCreateEvent = () => {
        // console.log("INSIDE HANDLE CREATE EVENT")
        /* clear active event and previous lists in order present user with empty form 
         and empty lists so they can go to process of creating new event */
        this.props.clearActiveEvent();
        // this.props.updateItemList([]);
        // this.props.updateParticipants([]);
    };

    handleOpenModal = (eventInfoObject) => {

        this.setState({showModal: true, currentEventObject: eventInfoObject});
    }

    handleCloseModal = () => {

        this.setState({showModal: false});

        this.props.startDeleteEvent(this.state.currentEventObject)
    }

    handleCancelModal = () => {

        this.setState({showModal: false});
    }


    //*************************************************************************
    // /SearchBar/SearchField function props
    //*************************************************************************

    // This function gets passed, via a prop, to the PicEventsSearchBar component, which in turn passes it to SearchField,
    // then SearchField calls the registrationFunction passing it the getFunction and clearFunction so it can
    // get registered here. These functions can then be called from this component to get or clear the searchValue
    // in the SearchField component
    registrationFunction = (getFunction, clearFunction) => {
        this.setState({
            getSearchValue: getFunction,
            clearSearchValue: clearFunction
        })
    }

    // Passed as function prop to PicEventsSearchBar and called when user 
    // submits search value from SearchField. This function invokes the search logic.
    onSubmit = (e) => {
        e.preventDefault();

        let searchFilterValue  = this.state.getSearchValue(); // call registered function from Search field component

        this.setState({searchFilterValue})
        this.state.clearSearchValue();  // clears the searchValue from the Searchfield input field.
    };
     
    //*************************************************************************
    // Handlers used to handle events from the content in an event list row
    //*************************************************************************

    eventTitleHandler = (eventId) => {

        let { list } = this.props.event;
        let target_event = list.find( (event) => {
            return event._id === eventId
        })
        
        return target_event;
    }

    //*************************************************************************
    // Function to get list of events 
    //*************************************************************************

    getEventList = (email) => {
        let self = this;
        let eventListPromise  = new Promise (

        function resolver(resolve, reject) {    
        
            // Pull out x-auth token from local storage. Server will find out users
            // email after checking authentication.
            let userToken = self.props.auth.token;
    
            /*Construct url for api call and set up header */
            let url    = getAppConfigParm("picUrl") + `/user/events`; 
            let header = getAppConfigParm("axiosConfig", userToken);
            // console.log("GET EVENT LIST")        
            axios.get(url, header)
                .then(function (response) {
                let eventList  = response.data.events || [];
                resolve(eventList);
                // dispatch(updateParticipants(participants));
            }).catch ((error) => {  /* TBD - this error should be logged to database */
                let errmsg = `Error encountered while trying to get list of events from DashboardPage for user email:${email}`
                self.props.picAppError(`Problem: something went wrong getting list of events; Try again later`);
                reject({errmsg});

            });

        }); /* end of promise */
        return eventListPromise;
    };
    
    //*************************************************************************
    // Helper functions
    //*************************************************************************
   
    /* Purpose of function is retrieve attendance, contribution, and participation metrics from redux store for a given
       event. If there is no metrics in redux store it returns 0 so the application does not error out in the render method */
    getEventMetrics = (event_id) => {
        let eventMetrics = {};
        let allMetrics = {};

        /* note that redux store maintains the event id as the property for the event metrics */
        if (!isEmpty(this.props.event.metrics)) {
            eventMetrics = this.props.event.metrics[event_id]; /* obtain metrics for given event from redux store*/
            allMetrics = { numItemsNeeded: eventMetrics.numItemsNeeded, numContributions: eventMetrics.numContributions,
                           numInvites: eventMetrics.numInvites, numAttending: eventMetrics.numAttending,
                           numPeopleNeeded: eventMetrics.numPeopleNeeded, numParticipants: eventMetrics.numParticipants
                         }; /* pull contrib metrics */
        } else {
            allMetrics = { numItemsNeeded: 0, numContributions: 0,
                           numInvites: 0, numAttending: 0,
                           numPeopleNeeded: 0, numParticipants: 0
                         }
        } 
        return allMetrics;
    }

    /* Helper function which returns true if eventList and metrics are loaded  */
    myEventsLoaded = () => {
        let eventListLength = !this.props.event.list ? 0 : this.props.event.list.length;
        return ((eventListLength === 0) &&  (this.props.event.metrics === null)  ||
               ( eventListLength  >  0) &&  (this.props.event.metrics !== null))
    }

    /* Returns true if invitedToList exist and length >=  0 */
    eventsInvitedToLoaded = () => {
        //trace && prtStart(compName, "eventsInvitedToLoaded");
        let eventsInvitedToLength = !this.props.event.invitedToList ? 0 : this.props.event.invitedToList.length;
        //trace && prtVar("eventsInvitedToLoadedLength", eventsInvitedToLength);
        let  loaded =  ((eventsInvitedToLength === 0) || (eventsInvitedToLength  >  0))
        //trace && prtVar("eventsInvitedToLoaded", loaded); 
        return loaded;
    }

    /* This function adjusts the view port height based on whether Ads are displayed or not. The function
       returns an object with the height property */
    setViewPortHeight = () => {
        // console.log("showAd is ==>", getAppConfigParm("showAd") )
        return getAppConfigParm("showAd") ? { minHeight: '73vh' } :  { minHeight: '70vh' }
    }

    // /* Increase margin top there is no Ad */
    //    getPageContainerStyle = () => {
    //     let showAd = getAppConfigParm("showAd");
    //     showAd ? { height: '73vh' } :  { height: '70vh' }
    // }

    /* display spinner when data is loading  */
    displaySpinner = () => (
        <div className="events-flex-table events-flex-table-spinner">
            <ProgressSpinner />
        </div>
    )

    /* This checks that eventList or All My Events are loaded, if not shows spinner. Note that picTableJsx renders the PicEventsTable component */
    renderMyEventsTable = (picTableJsx) => {
        return this.myEventsLoaded() ?  picTableJsx  
        :  this.displaySpinner()
    }

    /* This checks that eventList or All My Events are loaded, if not shows spinner. Note that picTableJsx renders the PicEventsTable component */
    renderEventsInvitedToTable = (picTableJsx) => {
        return this.myEventsLoaded() ?  picTableJsx  
        :  this.displaySpinner()
    }

    //*************************************************************************
    // Below are methods that provide the JSX for each column in the flex table.
    // Each jsx fragment is representative of a mini-component that gets inserted 
    // in the column of the flex table. Important Note: each column fragment
    // will effectively get replaced by a css tag called "events-flex-cell-'n'.
    // This css tag is found in the PicEventsTable itself. This wrapper
    // is essentially defines a cell in the flex table. 
    //*************************************************************************
    getColumn1_jsx = (eventTitle, startDate, eventId) => {

        return (
        <Fragment>
           <div className="events-flex-style-1-title-container">
            <Link to={`/liststatuses/${eventId}`}  className="events-flex-style-1-title" >{eventTitle}</Link>
           </div>
           <div className="events-flex-style-1-date"> 
             { format(new Date(startDate), 'MM/dd/YYYY') }
           </div>
        </Fragment>        
        )
    }

    getColumn2_jsx = (eventMetrics) => {
        let contribMetric = eventMetrics.numContributions + '/' + eventMetrics.numItemsNeeded;
        let attendMetric  = eventMetrics.numAttending + '/' + eventMetrics.numInvites;
        return (
        <Fragment>
           <div style={{display: 'flex'}} >
              <SimpleMetric label="Attending" bgColor="#c8e6c9" labelColor="#666" metricColor="#616161" metric={attendMetric} />
              <SimpleMetric label="Contributions" bgColor="#bbdefb" labelColor="#666" metricColor="#616161" metric={contribMetric} />
           </div>
        </Fragment>        
        )
    }

    getColumn3_jsx = (eventMetrics) => {
        let helpMetric = eventMetrics.numParticipants + '/' + eventMetrics.numPeopleNeeded;
        return (
            <div style={{marginRight: '3rem'}}>        
                <SimpleMetric label="Helping Hands" bgColor="#ffe0b2" labelColor="#666" metricColor="#616161" metric={helpMetric} />
            </div>        
        )
    }

    getColumn4_jsx = (eventId) => {

        /* get event oject for given eventId */
        let eventList = this.props.event.list;
        let eventInfoObject = eventList.find((event) => { return eventId === event._id })

        return (
        <Fragment>        
           <MuiVertMenu eventId={eventId} dashboardOpenModal={this.handleOpenModal.bind(this, eventInfoObject)} />
        </Fragment>        
        )
    }

    //*************************************************************************
    // This column4_jxs is used by the Events Invited To Listing
    //*************************************************************************

    getColumn4_jsx_for_eventsInvitedTo = (eventId) => {

        /* get event oject for given eventId */
        let eventsInvitedTo = this.props.event.invitedToList
        let eventInvitedToObject = eventsInvitedTo.find((event) => { return eventId === event._id })
        let organizer = !eventInvitedToObject.organizer ? eventInvitedToObject.name : eventInvitedToObject.organizer;

        return (
        <Fragment>        
           <div className="alt-view1-style-cell-2">Organizer</div>
           <div className="alt-view1-style-cell-2b">{organizer}</div>
        </Fragment>        
        )
    }

    //*************************************************************************
    // Component render method
    //*************************************************************************
    render() {
        //trace && prtStart(compName, "render()")

        /* Initialize variables from config and/or state */
        // let showAd  = getAppConfigParm("showAd");
        let showAd  = true;
        let showSkyScraper = false;    /* used to specifically turn off skyscraper. If you set value to true on Visibilily, addConditionalClassIf function does not work properly*/
        let { searchFilterValue } = this.state;
        //trace && prtInput("searchFilterValue", searchFilterValue); 

        /* Initialize  variables needed to render different collections (eg "All My Events", "Events Inited To" */
        let eventList         = [];
        let styledEventList   = [];
        let eventsInvitedTo   = [];
        let emptyTableMessage = "";
        let picEventsTableJsx = ""; 

        // Set eventListFilter to determine which event list to display (eg All My Events or "Events Invited To")
        let eventListFilter = this.props.picapp.filters.eventListFilter ? this.props.picapp.filters.eventListFilter : "All My Events";
        //trace && prtInput("eventListFilter", eventListFilter); 
       
        /* Create PicEventsTable Jsx based on eventListFilter selected. Note if user selects "All My Events", 
           "Upcoming Events", or "My Past Events" and the searchFilterValue, go against the "My Events" list. */
        if (eventListFilter === "All My Events" || eventListFilter === "My Upcoming Events" || "My Past Events") {

            /* Set the message to display, based on eventListFilter, when 'All My Events' table is empty */
            if (eventListFilter === "All My Events") {
                emptyTableMessage = "Hi! - Time to create new event. Click button below";
            } else if (eventListFilter === "My Upcoming Events") {
                emptyTableMessage = "You have no upcoming events to display";
            } else {
                emptyTableMessage = "You have no past events to display";
            }

            /* Initialize eventList, for 'All All My Events' */
            eventList  = this.props.event.list || []; /* get event list from redux store */
            // let eventList  = eventsInvitedTo;

            // console.log('EE >>>>> EE event list ', eventList)
            // let allMetrics = this.props.event.metrics;
        
            styledEventList = [];  /* init a styled event list array */
        
            // Convert eventList array of objects to an array of columns and insert the JSX fragments.
            if (eventList) {
                //trace && console.log(`   This is eventList before filtering and styling: ${JSON.stringify(eventList,null,2)}`)

                if (searchFilterValue) {     /* This modifies the eventList if user entered search value */
                    let lcSearchFilterValue = searchFilterValue.toLowerCase();
                    eventList =  eventList.filter(eventRow => eventRow.eventTitle.toLowerCase().includes(lcSearchFilterValue));
                }

                // Do Event List Filtering here before styling 
                /* If evenListFilter = "All My Events", Show all of My Events. Do not filter. */
                if (eventListFilter === "All My Events") {;}
                /* If evenListFilter = "My Upcoming Events", filter on My Upcoming Events. */
                if (eventListFilter === "My Upcoming Events") {
                    eventList = eventList.filter( eventRow => isAfter(eventRow.startDate, new Date())   );
                }
                /* If evenListFilter = "My Past Events", filter on My Past Events. */
                if (eventListFilter === "My Past Events") {
                    eventList = eventList.filter( eventRow => isBefore(eventRow.startDate, new Date())   );
                }
                // Convert event list to Styled JSX
                styledEventList = eventList.map( (eventRow) => {
                    let row = [];
                    row.push(this.getColumn1_jsx(eventRow.eventTitle, eventRow.startDate, eventRow._id));
                    row.push(this.getColumn2_jsx(this.getEventMetrics(eventRow._id)));
                    row.push(this.getColumn3_jsx(this.getEventMetrics(eventRow._id)));
                    row.push(this.getColumn4_jsx(eventRow._id));
                    return row;
                })
                /* there was a search value provide and eventList came up empty, change emptyTableMessage to "No Events Found" */
                if (searchFilterValue && eventList.length === 0) {emptyTableMessage = "No Events Found. To see full list, click search button again"}
            } 
            picEventsTableJsx = (
                <PicEventsTable rows = {styledEventList} emptymsg={emptyTableMessage} />
            )
        }
 
        /* Create PicEventsTable For "Events Invited To". If user enters a searchFilterValue, it will go against the Invited To List  */
        if (eventListFilter === "Events Invited To") {

            /* Set the message to display when 'All My Events' table is empty */
            emptyTableMessage = "There are no events in your Invited To List";

            /* Initialize eventList, for 'Invited to Events' */
            eventsInvitedTo = this.props.event.invitedToList ? this.props.event.invitedToList : [];
           
            styledEventList = [];  /* init a styled event list array */

            // Convert eventList array of objects to an array of columns and insert the JSX fragments.
            if (eventsInvitedTo) {
                if (searchFilterValue) {     /* This modifies the eventList if user entered search value */
                    let lcSearchFilterValue = searchFilterValue.toLowerCase();
                    eventsInvitedTo =  eventsInvitedTo.filter(eventRow => eventRow.eventTitle.toLowerCase().includes(lcSearchFilterValue));
                }
                styledEventList = eventsInvitedTo.map( (eventRow) => {
                    let row = [];
                    row.push(this.getColumn1_jsx(eventRow.eventTitle, eventRow.startDate, eventRow._id));
                    // row.push(<div>&nbsp;</div>);
                    // row.push(this.getColumn2_jsx(this.getEventMetrics(eventRow._id)));
                    // row.push(this.getColumn3_jsx(this.getEventMetrics(eventRow._id)));
                    row.push(this.getColumn4_jsx_for_eventsInvitedTo(eventRow._id));
                    return row;
                })
            } 
            picEventsTableJsx = (
                <PicEventsTable rows = {styledEventList} emptymsg={emptyTableMessage} view="alternateView1" />
            )
        }

        return (
            <div style={this.setViewPortHeight()}> 
                <Helmet>
                    <title>Dashboard Pitch In Club Events</title>
                    <meta name="description" content="Pitch In Club Dashboard Page" />
                </Helmet>
               {/*
               <div className={`"pic-dashboard ${addConditionalClass(showAd, 'rc-margin-top-medium')}"`} >    
               */}
               <VisibilityWrapper show={showAd} contentType="advertisement">
                <div className="rc-flex-container-center-hv"  style={{borderTop: '1px solid #95A5A6'}}>
                    {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                    {displayAd("mobile-leader-board", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                    {displayAd("web-leader-board", "tablet", {marginTop: '1.3rem', marginBottom: '1.3rem'})}
                </div>
               </VisibilityWrapper>  
               <div className="app-container" >    
             
                 <div className="pic-dashboard-container"> 
                 <div className={`pic-dashboard ${addConditionalClassIf(!showSkyScraper, 'rc-margin-top-medium')}`} >  
            {/*         <div className="pic-dashboard" >  */}
                                             
                        <PicEventsSearchBar 
                            onSubmit = {this.onSubmit}
                            registrationFunction={this.registrationFunction}
                        />
                        
                        { eventListFilter === "Events Invited To"    && this.renderEventsInvitedToTable(picEventsTableJsx) }
                        { eventListFilter === "All My Events"        && this.renderMyEventsTable(picEventsTableJsx) }
                        { eventListFilter === "My Upcoming Events"   && this.renderMyEventsTable(picEventsTableJsx) }
                        { eventListFilter === "My Past Events"       && this.renderMyEventsTable(picEventsTableJsx) }

                        <CancelSubmitModal showModal={this.state.showModal}  openHandler={this.handleOpenModal}  
                            closeHandler={this.handleCloseModal} cancelHandler={this.handleCancelModal} 
                            modalText="Are you sure you would like to Delete this Event?"
                        />
                        {/*
                        <div className="events-plus-icon-container" >
                            <Link to="/eventmanage/event" onClick={this.handleCreateEvent}>
                                 <PlusIcon />
                            </Link>     
                        </div>
                        */}
                    </div>
                    <VisibilityWrapper show={showSkyScraper} contentType="advertisement" >
                        {displayAd("skyscraper", "desktop", {marginLeft: '3rem', marginTop: '4.2rem'})}
                    </VisibilityWrapper>  
                  </div>
               </div>
               <VisibilityWrapper show={false} contentType="advertisement" >
                    <div className="rc-flex-container-center-hv" style={{borderTop: '1px solid #BDC3C7'}}> 
                        {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                        {displayAd("mobile-leader-board", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                        {displayAd("web-leader-board", "tablet", {marginTop: '1.5rem', marginBottom: '1.3rem'})}
                    </div> 
               </VisibilityWrapper>
               <Footer />  
            </div>          
        );
    };
};

const mapDispatchToProps = (dispatch) => ({
    initializeEventList:  (events) => dispatch(initializeEventList(events)),
    clearActiveEvent:     () => dispatch(clearActiveEvent()),
    updateItemList:       (list) => dispatch(updateItemList(list)),
    updateParticipants:   (list) => dispatch(updateParticipants(list)),
    startGetMyEventMetrics: (events) => dispatch(startGetMyEventMetrics(events)),
    clearAllEventMetrics: ()     => dispatch(clearAllEventMetrics()),
    updateAllEventMetrics: (eventMetrics) => dispatch(updateAllEventMetrics(eventMetrics)),
    startDeleteEvent:      (event_id) => dispatch(startDeleteEvent(event_id)),
    startGetEventsInvitedTo: ()  => dispatch(startGetEventsInvitedTo()),
    /* used to clear out application error */
    picAppError:          (errmsg) => dispatch(picAppError(errmsg))
    
})

const mapStateToProps = (state) => {
    return {
        event:  state.event,
        auth:   state.auth,
        picapp: state.picapp
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);


/*
<Link to="/event/:id" onClick={this.eventTitleHandler.bind(this, eventId)} className="events-flex-style-1-title" >{eventTitle}</Link>
*/


// WEBPACK FOOTER //
// ./src/components/DashboardPage.js